<template>
  <div class="article-detail">
    <article
      ref="chatContent"
      :class="isWechat ? 'fixed' : ''"
    >
      <div class="head">
        <h1 v-if="article.model.title">{{ processedTitle }}</h1>
        <div class="info">
          <div
            class="icon"
            v-if="article.isShow"
          ></div>

          <div
            class="source"
            v-if="article.model.source"
          >
            {{ article.model.source }}
          </div>

          <div
            class="author"
            v-if="article.model.author"
          >
            {{ article.model.author }}
          </div>

          <div
            class="time"
            v-if="article.model.publishTime"
          >
            {{ article.model.publishTime.substr(0, 10) }}
          </div>

          <div
            class="badge"
            v-if="article.model.badge"
          >
            {{ article.model.badge }}
          </div>

          <div
            class="number"
            v-show="false"
          >
            {{ article.model.hits + article.model.fakeHits }}
          </div>
        </div>
      </div>
      <div class="head-advert">
        <van-swipe
          :show-indicators="false"
          :autoplay="3000"
          lazy-render
        >
          <van-swipe-item
            v-for="(item, index) in article.advertHeadList"
            :key="index"
          >
            <van-image
              class="channel-header-image"
              :src="item.img"
              @click="clickHeadImage(item)"
            />
          </van-swipe-item>
        </van-swipe>
      </div>
      <div
        v-if="viewModel === 'detail' && infoExtend?.summary_list?.length > 0"
        :class="['ai-wrap', article.model.audio ? '' : 'no-audio']"
      >
        <img
          src="@/assets/img/ai-read.png"
          class="icon-read"
          @click="toAiRobot"
        />
        <img
          :src="iconSummary"
          class="icon-summary"
          @click="showSummaryPreview = !showSummaryPreview"
        />
        <div
          class="audio-cell"
          v-if="article.model.audio"
        >
          <img
            :src="iconRadio"
            class="icon-audio"
            @click="handlePlayAudio"
          />
          <span class="audio-time">约{{ article.audioDuration }}秒</span>
        </div>
      </div>
      <Transition name="summary-fade">
        <SummaryPreview
          :list="infoExtend?.summary_list"
          v-show="showSummaryPreview"
        />
      </Transition>
      <div
        id="article-content"
        class="app-main-content"
      >
        <div
          v-if="
            (article.model.audio && viewModel === 'preview') ||
            (article.model.audio && infoExtend?.summary_list?.length === 0)
          "
          class="audio-tips"
          @click="handlePlayAudio"
        >
          <div class="audio-tips-left">
            <img src="@/assets/img/icon-top-audio.png" />
            <div class="left-text">点击听全文</div>
          </div>
          <div class="audio-tips-right">
            <div class="right-text">全长约{{ article.audioDuration }}秒</div>
          </div>
        </div>

        <van-skeleton
          title
          :row="20"
          :loading="!article.content"
        >
          <div
            class="content-detail"
            v-html="article.content"
            @click="handleClick($event)"
          ></div>
        </van-skeleton>
      </div>
      <div
        class="find_reporter"
        v-if="reporterList.length > 0"
      >
        <div class="find_reporter_title">
          <van-icon
            class="find_reporter_icon"
            :name="require('../assets/img/find_reporter_icon.png')"
            size="24"
          />
          <div>本文作者</div>
        </div>
        <div class="reporters_list">
          <div
            class="reporters_box"
            v-for="(item, index) in reporterList"
            :key="index"
            @click="toReporterDetail(item)"
          >
            <img
              :src="item.image"
              alt=""
              class="reporters_box_img"
            />
            <div class="reporters_box_right">
              <div class="reporters_box_right_top">
                <div class="left_item">{{ item.name }}</div>
                <div class="right_item">报料</div>
              </div>
              <div class="reporters_box_right_bottom line-2">
                {{ item.remark }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="advert"
        v-if="article.advert && article.advert.length > 0"
      >
        <van-swipe
          :show-indicators="false"
          :autoplay="3000"
          lazy-render
        >
          <van-swipe-item
            v-for="(item, index) in article.advert"
            :key="index"
          >
            <van-image
              class="channel-header-image"
              :src="item.img"
              @click="clickHeadImage(item)"
            />
          </van-swipe-item>
        </van-swipe>
      </div>
      <div
        class="comment-list"
        v-if="infoList && infoList.length > 0"
      >
        <div class="comment-title">
          <div class="comment-title-text">
            <van-icon
              class="comment-icon"
              :name="require('../assets/img/comment_icon.png')"
              size="24"
            />
            <div>最新评论</div>
          </div>
          <!-- <div
            v-if="isWechat"
            class="comment-more"
            @click="$router.push(`/commonList/${$route.params.id}`)"
          >
            更多
          </div> -->
        </div>
        <div
          class="comment-item"
          v-for="item in infoList"
          :key="item.id"
        >
          <div class="comment-item-hd">
            <div class="comment-item-hd-avatar">
              <van-image
                fit="cover"
                round
                class="common-item-header"
                :src="item.head"
                @click.stop="toHomePage(item.home_page_url)"
              />
              <div class="comment-item-hd-left">
                <span class="nickname"
                  ><div
                    class="line-1"
                    style="max-width: 160px"
                  >
                    {{ item.nick_name }}
                  </div>
                  <div v-if="item.is_rewarded">
                    <div class="reward-amount">
                      <div class="redpocket-icon">
                        <img
                          src="@/assets/img/redpocket.png"
                          alt="红包"
                        />
                      </div>
                      <div class="reward-amount-text">
                        已获红包<span
                          v-if="item.reward_amount >= 1"
                          class="reward-amount-text-value"
                          ><span>{{ item.reward_amount }}</span
                          >元</span
                        >
                      </div>
                    </div>
                  </div>
                  <!-- <van-image
                    v-if="item.is_rewarded"
                    fit="cover"
                    round
                    class="common-git"
                    :src="require('@/assets/img/common-gif.png')"
                  /> -->
                </span>
                <span class="time">{{ item.create_time }} </span>
              </div>
            </div>
            <div class="comment-item-hd-right">
              <div class="comment-right">
                <!-- <van-icon
                  v-if="!item.is_me"
                  name="comment-o"
                  :badge="item.comment_count == 0 ? '' : item.comment_count"
                  size="18"
                  @click="handleComment(item)"
                /> -->
                <van-icon
                  v-if="!item.is_like"
                  class="like-icon"
                  @click="handleLike(item)"
                  color="#767677"
                  name="like-o"
                  size="18"
                />
                <van-icon
                  v-if="item.is_like"
                  class="like-icon"
                  @click="handleLike(item)"
                  name="like"
                  color="#FF3333"
                  size="18"
                />
                <div
                  class="like-num"
                  v-if="item.like_num > 0"
                >
                  {{ item.like_num }}
                </div>
              </div>
            </div>
          </div>
          <!-- 此版本不可回复 @click="handleComment(item)" -->
          <div class="comment-item-ft">
            {{ item.content }}
          </div>
          <div
            class="common-item-reply"
            v-if="item.sub_comments && item.sub_comments.length > 0"
          >
            <div v-if="item.sub_comments && item.sub_comments.length > 0">
              <div
                class="common-item-reply-item"
                :style="
                  sub_index > 1 && !item.show_sub_comments ? 'padding : 0' : ''
                "
                v-for="(sub_item, sub_index) in item.sub_comments"
                :key="sub_index"
              >
                <div
                  v-if="sub_index === 0 || item.show_sub_comments"
                  class="common-item-reply-item-header"
                >
                  <div class="common-item-reply-item-header-left">
                    <van-image
                      fit="cover"
                      round
                      class="common-item-reply-item-header-img"
                      @click="toHomePage(sub_item.home_page_url)"
                      :src="sub_item.head"
                    />
                    <span
                      class="common-item-nick-name"
                      @click.stop="toHomePage(sub_item.home_page_url)"
                      ><div
                        class="line-1"
                        style="max-width: 160px"
                      >
                        {{ sub_item.nick_name }}
                      </div>
                      <van-image
                        v-if="sub_item.is_rewarded"
                        fit="cover"
                        round
                        class="common-git"
                        :src="require('@/assets/img/common-gif.png')"
                    /></span>
                  </div>
                  <div class="common-item-reply-item-like">
                    <van-icon
                      @click="handleLike(sub_item)"
                      class="common-item-reply-item-like-icon"
                      :name="!sub_item.is_like ? 'like-o' : 'like'"
                      :color="!sub_item.is_like ? '#767677' : '#FF3333'"
                      size="18"
                    />
                    <div
                      class="like-num"
                      v-if="sub_item.like_num > 0"
                    >
                      {{ sub_item.like_num }}
                    </div>
                  </div>
                </div>
                <div
                  v-if="sub_index === 0 || item.show_sub_comments"
                  class="common-item-reply-content"
                >
                  <span
                    v-if="sub_item.reply_nick_name"
                    @click="comment(sub_item)"
                  >
                    <span class="common-item-text">回复</span>
                    <span
                      class="common-item-reply-reply-name"
                      @click.stop="toHomePage(sub_item.reply_home_page_url)"
                      >{{ sub_item.reply_nick_name }}</span
                    >：</span
                  >
                  {{ sub_item.content }}
                </div>
                <div
                  v-if="sub_index === 0 || item.show_sub_comments"
                  class="common-item-reply-bottom"
                >
                  <div class="common-item-reply-date">
                    {{ sub_item.create_time }}
                  </div>
                </div>
              </div>
            </div>
            <span
              v-if="!item.show_sub_comments && item.sub_comments.length > 1"
              class="common-item-reply-count"
              @click="item.show_sub_comments = true"
            >
              展开{{ item.sub_comments.length - 1 }}条回复
              <van-icon name="arrow-down" />
            </span>
          </div>
        </div>
        <div
          class="load-more"
          v-if="infoListTotal > infoList.length"
          @click="loadMore"
        >
          点击加载更多
        </div>
      </div>
      <div
        class="article-list article-relate-list recommend-list"
        v-if="relateList.length > 0"
      >
        <div class="recommend-title">
          <van-icon
            class="find_reporter_icon"
            :name="require('../assets/img/news_icon.png')"
            size="24"
          />
          <div style="font-weight: 700">推荐阅读</div>
        </div>
        <div
          v-for="(item, index) in relateList"
          :key="index"
        >
          <div
            class="item bigimg clearfix"
            v-if="item.list_type == 1"
            @click="goRelateDetail(item)"
          >
            <div class="title">
              {{ item.title }}
            </div>
            <div class="img">
              <img
                class="lazyload"
                alt=""
                :src="cdn(item.img)"
              />
            </div>
            <div class="info">
              <div class="left">
                <span
                  class="badge"
                  v-if="item.badge"
                  >{{ item.badge }}</span
                >
                <span class="time">{{ item.publish_time }}</span>
              </div>
            </div>
          </div>
          <div
            class="item imgset clearfix"
            v-else-if="item.list_type == 2"
            @click="goRelateDetail(item)"
          >
            <div class="title">
              {{ item.title }}
            </div>
            <div class="img">
              <img
                class="lazyload"
                :src="cdn(img)"
                alt=""
                v-for="(img, inde) in item.list_imgs"
                v-bind:key="inde"
              />
            </div>
            <div class="info">
              <div class="left">
                <span
                  class="badge"
                  v-if="item.badge"
                >
                  {{ item.badge }}
                </span>
                <span class="time">
                  {{ item.publish_time }}
                </span>
              </div>
            </div>
          </div>
          <div
            class="item normal clearfix"
            v-else
            @click="goRelateDetail(item)"
          >
            <div class="img">
              <img
                class="lazyload"
                alt=""
                :src="cdn(item.img)"
              />
            </div>
            <div class="txt">
              <div class="title">
                {{ item.title }}
              </div>
              <div class="info">
                <div class="left">
                  <span
                    class="badge"
                    v-if="item.badge"
                  >
                    {{ item.badge }}
                  </span>
                  <span class="time">
                    {{ item.publish_time }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </article>
    <div class="divider"></div>
    <div
      class="channels"
      v-if="isWechat"
    >
      <div class="channel-header">
        <van-image
          fit="contain"
          class="channel-header-image"
          :src="require('@/assets/img/channel-header-left.png')"
        />
        <div class="channel-header-title">更多精彩内容请点击频道查看</div>
        <van-image
          fit="contain"
          class="channel-header-image"
          :src="require('@/assets/img/channel-header-right.png')"
        />
      </div>
      <van-grid
        class="channel-detail"
        :border="false"
      >
        <van-grid-item
          v-for="(item, index) in article.bottomCategory"
          v-bind:key="index"
          class="channel-detail-item"
          ><wx-open-launch-app
            id="launch-btn"
            appid="wxc9da92efaf026389"
            style="width: 100%; height: 100%"
            :extinfo="'category_id=' + item.categoryId"
            @launch="handleLaunch"
            @error="handleChannelError"
          >
            <component
              :is="'script'"
              v-bind="{ type: 'text/wxtag-template' }"
            >
              <button
                style="
                  font-size: 12px;
                  line-height: 12px;
                  width: 100%;
                  border-radius: 6px;
                  border-width: 0px;
                  height: 30px;
                  color: #949494;
                  background: #fafafa;
                  white-space: nowrap;
                "
              >
                {{ item.title }}
              </button>
            </component>
          </wx-open-launch-app>
        </van-grid-item>
      </van-grid>
    </div>
    <div
      v-if="article.dataInfo && isWechat"
      style="width: 100vw; height: 42px; overflow: hidden"
    >
      <wx-open-launch-app
        v-if="isWechat"
        id="launch-btn"
        appid="wxc9da92efaf026389"
        style="width: 100vw; height: 25vw"
        :extinfo="article.dataInfo"
        @launch="handleLaunch"
        @error="handleError"
      >
        <component
          :is="'script'"
          v-bind="{ type: 'text/wxtag-template' }"
        >
          <button
            style="
              color: white;
              font-size: 14px;
              background: linear-gradient(to bottom, #e53531, #f48260);
              border-radius: 19px;
              border: 0;
              width: 56vw;
              height: 40px;
              margin: 0 22vw 10vw;
            "
          >
            打开中山+APP查看
          </button>
        </component>
      </wx-open-launch-app>
    </div>
    <div
      class="complaint"
      @click="toComplaint"
    >
      网上有害信息举报专区
    </div>
    <div
      class="mask"
      v-if="isSend"
      @click="handleBlur"
    ></div>
    <div
      class="footer"
      v-if="isWechat && $route.params.id && infoExtend.is_comment === 1"
    >
      <div
        class="chat-footer"
        @click="toChatPage"
      >
        <div
          class="chat-input"
          :class="[`input${typeCount}`]"
        >
          <van-field
            v-show="!isSend"
            class="search-input"
            rows="1"
            :autosize="{ maxHeight: 60 }"
            type="textarea"
            left-icon="edit"
            placeholder="写评论领随机红包"
            maxlength="200"
            readonly
            @focus="handleFocus"
          />
          <van-field
            v-show="isSend"
            ref="fieldRef"
            v-model="searchValue"
            class="search-input scrollable-field"
            rows="1"
            :autosize="{ maxHeight: 60 }"
            label=""
            type="textarea"
            placeholder="下载中山+写评论可领随机红包"
            label-width="0"
            maxlength="200"
            :show-word-limit="searchValue !== ''"
            @input="checkOverflow"
            @focus="handleFocus"
          />
          <div
            v-if="lineCount >= 3"
            class="operate-btn"
            @click="isExpanded = !isExpanded"
          >
            <svg
              v-if="!isExpanded"
              class="icon"
              aria-hidden="true"
              style="width: 20px; height: 20px"
            >
              <use xlink:href="#icon-zhankai"></use>
            </svg>
          </div>
          <!-- <div
            :class="['send-btn', searchValue.trim() !== '' ? 'active' : '']"
            @click="toChat(searchValue.trim())"
          >
            <van-icon name="guide-o" size="22" color="#fff" />
          </div> -->
        </div>
      </div>
      <div
        class="chat-right"
        :style="!isSend ? 'padding: 0 15px 0 4px;' : 'padding-right: 10px;'"
      >
        <div
          v-if="infoExtend && !isSend"
          class="chat-right-cell"
        >
          <img
            class="footer-chat-icon"
            src="@/assets/img/icon-comment.png"
            @click="toCommentList"
          />
          <div>
            {{
              infoExtend.comment_count === 0
                ? "评论"
                : infoExtend.comment_count > 1000
                ? "999+"
                : infoExtend.comment_count
            }}
          </div>
        </div>
        <div
          v-if="infoExtend && !isSend"
          class="chat-right-cell"
        >
          <img
            class="footer-chat-icon"
            :src="infoExtend.is_like == 1 ? likeActive : like"
            @click="handleArticlesLike(infoExtend)"
          />
          <div
            :style="{ color: infoExtend.is_like == 1 ? '#e53531' : '#4E5969' }"
          >
            {{
              infoExtend.info_like_num == 0
                ? "点赞"
                : infoExtend.info_like_num > 1000
                ? "999+"
                : infoExtend.info_like_num
            }}
          </div>
        </div>
        <div
          v-if="infoExtend && !isSend"
          class="chat-right-cell"
          @click="showFontSetting = true"
        >
          <img
            class="footer-chat-icon"
            src="@/assets/img/icon-font-setting.png"
          />
          <div>字号</div>
        </div>
        <van-button
          v-if="isSend"
          class="submit-btn"
          round
          :loading="loading"
          :disabled="loading"
          loading-text="发送中..."
          @click="toChat(searchValue.trim())"
        >
          发送
        </van-button>
      </div>
    </div>

    <van-popup
      v-model:show="isExpanded"
      position="bottom"
      :style="{ height: '300px' }"
      @opened="onPopupOpened"
      @closed="onPopupClosed"
    >
      <div class="pop-box">
        <div class="pop-title">
          <svg
            class="icon"
            aria-hidden="true"
            style="width: 20px; height: 20px"
            @click="handleChangeExpanded"
          >
            <use xlink:href="#icon-shousuo"></use>
          </svg>
        </div>
        <div class="pop-content">
          <van-field
            ref="popFieldRef"
            v-model="searchValue"
            label=""
            class="pop-input scrollable-field"
            type="textarea"
            placeholder="写评论领随机红包"
            maxlength="200"
            :show-word-limit="searchValue !== ''"
            label-width="0"
            @focus="isFocused = true"
            @blur="isFocused = false"
          />
        </div>
        <div class="pop-btm">
          <div
            :class="['pop-btn', searchValue.trim() !== '' ? 'active' : '']"
            @click="toChat()"
          >
            <van-icon
              name="guide-o"
              size="20"
              color="#fff"
            />
          </div>
        </div>
      </div>
    </van-popup>
    <div v-if="isWechat">
      <StatementPopup
        v-model:show="showTurnApp"
        :exinfo="article.dataInfo"
      />
    </div>
  </div>
  <AudioPlayer
    ref="newsAudioPlayer"
    :audio-url="article.model.audio"
    :img-url="article.model.img"
    :title="article.model.title"
  />
  <FontSetting
    ref="fontSettingRef"
    v-model:show="showFontSetting"
    @close="showFontSetting = false"
    @update:show="showFontSetting = $event"
  />
</template>

<script>
import {
  Image as VanImage,
  Grid,
  GridItem,
  Swipe,
  SwipeItem,
  Icon,
  Progress,
  Skeleton,
  Field,
  Popup,
  Button
} from "vant";
import { Toast, ImagePreview } from "@vant/compat";
import { computed, onMounted, ref, nextTick, onUnmounted, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import Api from "../api";
import Cookies from "js-cookie";
import { triggerLogin } from "@/utils/triggerLogin";
import StatementPopup from "@/components/StatementPopup.vue";
import AudioPlayer from "@/components/AudioPlayer.vue"; // 音频播放组件
import FontSetting from "@/components/FontSetting.vue"; // 字号设计组件
import SummaryPreview from "./SummaryPreview.vue"; // 要点速览组件
import useVote from "@/composiables/useVote";
import useGetImage from "@/composiables/useGetImage";

// 引入图片
import likeActive from "@/assets/img/icon-like-active.png";
import like from "@/assets/img/icon-like.png";

import iconSummary from "@/assets/img/ai-summary.png";
import iconSummaryActive from "@/assets/img/ai-summary-active.png";
import iconRadio from "@/assets/img/ai-radio.png";
import iconRadioActive from "@/assets/img/ai-radio-active.png";

export default {
  name: "NormalNewsDetail",
  components: {
    [VanImage.name]: VanImage,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Icon.name]: Icon,
    [Progress.name]: Progress,
    [Skeleton.name]: Skeleton,
    [Field.name]: Field,
    [Popup.name]: Popup,
    [Button.name]: Button,
    StatementPopup,
    AudioPlayer,
    FontSetting,
    SummaryPreview
  },
  props: {
    article: { type: Object, default: () => ({ model: {} }) },
    reporterList: { type: Array, default: () => [] },
    relateList: { type: Array, default: () => [] },
    infoList: { type: Array, default: () => [] },
    infoListTotal: { type: Number, default: 0 },
    infoExtend: { type: Object, default: () => ({}) },
    viewModel: { type: String, default: "detail" }
  },
  emits: ["loadMore"],
  setup(props, { emit }) {
    const route = useRoute();
    const router = useRouter();
    const userAgentString = navigator.userAgent.toLowerCase();
    const isWechat = userAgentString.indexOf("micromessenger") >= 0;
    const isApp = userAgentString.indexOf("zsrbapp") >= 0;
    const vote = useVote();
    const searchValue = ref("");
    const chatContent = ref(null);
    const isFocused = ref(false); // 输入款是否获取焦点
    const isExpanded = ref(false); // 是否展开输入框
    const lineCount = ref(1); // 判断输入款显示行数
    const typeCount = ref(1); // 判断输入款显示字数
    const fieldRef = ref(null); // 输入框
    const popFieldRef = ref(null); // 弹出框输入框容器
    const textarea = ref(null); // 输入框
    const isSend = ref(false);

    const showTurnApp = ref(false); // 弹出app下载提示框

    const showSummaryPreview = ref(false); // 弹出要点速朗

    const newsAudioPlayer = ref(null); // 音频播放组件
    const audioIconSrc = computed(() => {
      // 音频播放按钮
      if (
        newsAudioPlayer.value &&
        (newsAudioPlayer.value.playStatus === "play" ||
          newsAudioPlayer.value.playStatus === "resume")
      ) {
        return iconRadioActive;
      }
      return iconRadio;
    });
    const fontSettingRef = ref(null); // 字号设置弹窗组件
    const showFontSetting = ref(false); // 字号设置弹窗是否显示

    const photos = computed(() => {
      if (!props.article.content) return [];
      return useGetImage(props.article.content);
    });

    const toAiRobot = () => {
      if (userAgentString.indexOf("zsrbapp") >= 0) {
        window.ZsrbApp.call("viewInfo", {
          type: "",
          id: "",
          title: "",
          img: "",
          summary: "",
          url: `https://zsrbactivity.zsnews.cn/vue/activity-aichat/#/news_detail/${route.params.id}`,
          isComment: 0,
          commentCount: 0
        });
      } else if (userAgentString.indexOf("micromessenger") >= 0) {
        window.open(
          `https://zsrbactivity.zsnews.cn/vue/activity-aichat/#/news_detail/${route.params.id}`,
          "_blank"
        );
      } else {
        Toast("请在中山+APP或微信环境打开");
      }
    };

    const handlePlayAudio = () => {
      // 触发子组件播放
      nextTick(() => {
        if (newsAudioPlayer.value) {
          // 父组件只负责播放功能，不负责暂停功能
          newsAudioPlayer.value.handleControl("play");
        }
      });
    };

    const handleFocus = () => {
      if (props.article.model.isComment == 0) {
        Toast("该稿件不支持评论");
        return;
      }
      isFocused.value = true;
      isSend.value = true;
      disableScroll();
      nextTick(() => {
        if (fieldRef.value) {
          fieldRef.value.focus();
          enableFilderdScroll();
        }
      });
    };
    const handleBlur = () => {
      lineCount.value = 1;
      isFocused.value = false;
      isSend.value = false;
      enableScroll();
    };
    //允许filderd 滚动
    const enableFilderdScroll = () => {
      // 获取需要允许滚动的元素
      const scrollableElement = document.querySelector(".scrollable-field");
      // 阻止事件冒泡
      scrollableElement.addEventListener(
        "touchmove",
        (event) => {
          event.stopPropagation();
        },
        { passive: false }
      );
    };

    // 当 van-popup 打开时绑定事件监听器
    const onPopupOpened = () => {
      nextTick(() => {
        enableScroll();
      });
    };
    const onPopupClosed = () => {
      handleFocus();
    };

    const handleChangeExpanded = () => {
      isExpanded.value = !isExpanded.value;
      enableFilderdScroll();
    };

    const disableScroll = () => {
      document.addEventListener("touchmove", preventDefault, {
        passive: false
      });
    };

    const enableScroll = () => {
      document.removeEventListener("touchmove", preventDefault);
    };

    const preventDefault = (e) => {
      e.preventDefault();
    };

    onUnmounted(() => {
      enableScroll();
    });
    // 监听文字输入
    const checkOverflow = async () => {
      textareaResize();
    };
    // 监听输入框高度变化
    const textareaResize = () => {
      textarea.value = fieldRef.value?.$el.querySelector("textarea");
      if (!textarea.value) return;
      lineCount.value = Math.ceil(textarea.value.scrollHeight / 20);
      typeCount.value = lineCount.value > 3 ? 3 : lineCount.value;
    };
    const loading = ref(false);
    const toChat = () => {
      console.log("键盘确认事件被触发，输入值为：", searchValue.value);
      if (loading.value) return;
      postComment();
    };

    const postComment = () => {
      loading.value = true;
      if (searchValue.value == "") {
        Toast.fail("评论内容不得为空");
        loading.value = false;
        return;
      }
      const params = {
        info_id: route.params.id,
        parent_id: currentCommentItem.value.id || 0,
        content: searchValue.value
      };

      const sessionToken = sessionStorage.getItem("session_token");
      if (!sessionToken && isApp) {
        triggerLogin();
        return;
      }

      Api.postComment(params)
        .then((res) => {
          if (res.code == 1) {
            // Toast.success(res.message);
            searchValue.value = "";
            isExpanded.value = false;
            textareaResize();
            loading.value = false;
            lineCount.value = 1;
            handleBlur();
            handleBuried("comment");
            showTurnApp.value = true;
          } else {
            Toast.fail(res.message);
            loading.value = false;
            showTurnApp.value = false;
          }
        })
        .catch(() => {
          loading.value = false;
          showTurnApp.value = false;
        });
    };

    //埋点
    const handleBuried = (type) => {
      // 南方智媒云数据上报
      if (type == "comment") {
        window.TrackKit.zmyAdapter.commentArticle({
          article_id: route.params.id
        });
      } else if (type === "like") {
        window.TrackKit.zmyAdapter.likeArticle({
          article_id: route.params.id
        });
      }
    };

    const handleClick = (e) => {
      console.log(e.target);
      if (
        e.target.tagName == "IMG" &&
        photos.value.length > 0 &&
        !e.target.parentNode.href
      ) {
        let url = e.target.src;
        if (url.indexOf("http") == -1) {
          url = "https://zsrbapp.zsnews.cn" + url;
        }
        const index = photos.value.indexOf(url);
        if (userAgentString.indexOf("zsrbapp") >= 0) {
          window.ZsrbApp.call("gallery", {
            currentIndex: index,
            photos: photos.value
          });
        } else {
          ImagePreview({
            images: photos.value,
            startPosition: index,
            closeable: true
          });
        }

        if (vote.handleVoteImageClick(e.target)) return;
      }
      // 点击a标签判断是否外链，不是外链使用router跳转
      if (e.target.tagName == "A") {
        e.preventDefault();
        const href = e.target.getAttribute("href");
        if (isInternalLink(href)) {
          router.push(href.match(/#\/(\d+)$/)[1]);
        } else {
          // 外部链接
          window.open(href, "_blank");
        }
      }

      if (vote.handleVoteItemClick(e)) return;
    };

    const isInternalLink = (url) => {
      // 根据你的路由配置来转换全路径为内部路由路径
      // 判断是否为内部链接，可以根据实际需求调整逻辑
      return url.indexOf(window.location.pathname) !== -1;
    };

    const handleLaunch = (e) => {
      console.log("handleLaunch", e);
    };

    const handleError = (e) => {
      console.log("handleError", e);
      window.open(props.article.apkLink, "_blank");
    };

    const handleChannelError = (e) => {
      const categoryId = e.detail.extInfo.substr(12);
      if (categoryId && categoryId.length > 0) {
        window.open(
          "https://zsrbapp.zsnews.cn/mobile/channel/#/?categoryId=" +
            categoryId,
          "_blank"
        );
      }
    };
    const toComplaint = () => {
      window.open("https://www.12377.cn/", "_blank");
    };

    const toReporterDetail = (item) => {
      if (userAgentString.indexOf("zsrbapp") >= 0) {
        window.ZsrbApp.call("viewInfo", {
          type: "",
          id: "",
          title: "",
          img: "",
          summary: "",
          url: `https://zsrbapp.zsnews.cn/mobile/find_reporters/#/index/${item.id}`,
          isComment: 0,
          commentCount: 0
        });
      } else if (userAgentString.indexOf("micromessenger") >= 0) {
        window.open(
          `https://zsrbapp.zsnews.cn/mobile/find_reporters/#/index/${item.id}`,
          "_blank"
        );
      }
    };

    const toHomePage = (url) => {
      if (url) {
        if (userAgentString.indexOf("zsrbapp") >= 0) {
          window.ZsrbApp.call("viewInfo", {
            type: "",
            id: "",
            title: "",
            img: "",
            summary: "",
            url,
            isComment: 0,
            commentCount: 0
          });
        } else if (userAgentString.indexOf("micromessenger") >= 0) {
          window.open(url, "_blank");
        }
      }
    };

    const clickHeadImage = (item) => {
      if (item.url) {
        window.open(item.url, "_blank");
      } else if (item.img) {
        ImagePreview({
          images: [item.img]
        });
      }
    };
    const cdn = (
      imageUrl,
      domain = process.env.VUE_APP_UPLOAD_CDN_URL + "/storage"
    ) => {
      if (!imageUrl) {
        return "";
      }
      // 使用正则表达式检查图片地址是否包含域名
      const hasDomain = /:\/\//.test(imageUrl);
      if (!hasDomain) {
        // 如果图片地址没有域名，则补充默认域名
        const pathStartsWithSlash = imageUrl.startsWith("/");
        const path = pathStartsWithSlash ? imageUrl : `/${imageUrl}`;
        imageUrl = `${domain}${path}`;
      }
      return imageUrl;
    };

    const goRelateDetail = (item) => {
      if (userAgentString.indexOf("zsrbapp") >= 0) {
        Api.getViewInfoBridging(item.id).then((res) => {
          window.ZsrbApp.call("viewInfo", res.data);
        });
      } else {
        window.open(item.url);
      }
    };

    const currentCommentItem = ref({});

    //评论点击回复
    const handleComment = (item) => {
      if (!item.is_me) {
        currentCommentItem.value = item;
        isExpanded.value = true;
        enableFilderdScroll();
      }
    };
    //加载更多评论
    const loadMore = () => {
      emit("loadMore", {
        id: route.params.id,
        page: 1,
        page_size: props.infoList.length + 20
      });
    };

    const handleLike = (item) => {
      const sessionToken = sessionStorage.getItem("session_token");
      if (!sessionToken && isApp) {
        triggerLogin();
        return;
      }

      Api.postLike(item.id).then((res) => {
        if (res.code == 1) {
          item.is_like = !item.is_like;
          item.like_num = item.like_num + (!item.is_like ? -1 : 1);
        } else {
          Toast.fail(res.message || "操作失败");
        }
      });
    };

    const toCommentList = () => {
      if (props.article.model.isComment == 0) {
        Toast("该稿件不支持评论");
        return;
      }
      router.push(`/commonList/${route.params.id}`);
    };

    //点赞文章
    const handleArticlesLike = (item) => {
      const sessionToken = sessionStorage.getItem("session_token");
      if (!sessionToken && isApp) {
        triggerLogin();
        return;
      }
      Api.postLikeArticle(route.params.id).then((res) => {
        if (res.code == 1) {
          Toast.success(res.message);
          item.is_like = !item.is_like;
          item.info_like_num += item.is_like ? 1 : -1;
          handleBuried("like");
        } else {
          Toast.fail(res.message);
        }
      });
    };

    const toChatPage = () => {
      currentCommentItem.value = {};
    };

    // 设置 summary-box 下所有 u-summary-order 元素的字号，u-order 由异步数据 v-for 渲染，
    // 在挂载时可能尚未生成，故提取为函数，供 onMounted 与 watch 共用
    const updateSummaryOrderFontSize = () => {
      const fontSize = Number(localStorage.getItem("zsplus-fontSize"));
      if (!fontSize) return;
      nextTick(() => {
        const summaryEl = document.querySelector(".summary-box");
        if (!summaryEl) return;
        const summaryOrderEls = summaryEl.querySelectorAll(".u-summary-order");
        summaryOrderEls.forEach((el) => {
          el.style.fontSize = `${fontSize - 4}px`;
        });
      });
    };

    // 监听要点速览数据变化，数据到达后再设置 u-summary-order 字号
    watch(
      () => props.infoExtend?.summary_list,
      () => {
        updateSummaryOrderFontSize();
      },
      { deep: true }
    );

    // 注入全局设置字体全局方法，提供app设置字体使用，app端调用时传递的值为：small/medium/large/xlarge
    const appSetFontSize = (size) => {
      // 增加 null 校验，防止子组件未挂载时报错
      if (!fontSettingRef.value) {
        console.warn("字体设置组件还没初始化！");
        return;
      }
      // 根据值调用子组件的setFontSize方法
      if (size == "small") {
        fontSettingRef.value.setFontSize(16);
      } else if (size == "medium") {
        fontSettingRef.value.setFontSize(18);
      } else if (size == "large") {
        fontSettingRef.value.setFontSize(20);
      } else if (size == "xlarge") {
        fontSettingRef.value.setFontSize(22);
      }
    };

    onMounted(() => {
      // 从localStorage中获取字体大小
      const fontSize = localStorage.getItem("zsplus-fontSize");
      if (fontSize) {
        const contentEl = document.querySelector(".app-main-content");
        const summaryEl = document.querySelector(".summary-box");
        if (contentEl) {
          contentEl.style.fontSize = `${fontSize}px`;
        }
        if (summaryEl) {
          summaryEl.style.fontSize = `${fontSize - 2}px`;
        }
        // u-summary-order 元素由异步数据 v-for 渲染，挂载时可能还未生成，
        // 统一通过 updateSummaryOrderFontSize 在 watch 中处理
        updateSummaryOrderFontSize();
      }
      // 注入全局设置字体appSetFontSize全局方法，提供app设置字体使用
      nextTick(() => {
        window.appSetFontSize = appSetFontSize;
      });

      vote.initVote();
      //阅读新闻加积分任务(APP环境下)
      if (userAgentString.indexOf("zsrbapp") >= 0) {
        const sessionToken = sessionStorage.getItem("session_token");

        if (sessionToken) {
          Api.ReadingNews({
            unique_id: route.params.id,
            task_name: "ReadNews"
          }).then((res) => {
            if (res.code == 1) {
              const data = res?.data;
              if (data && data.add_point > 0 && data.toast_message) {
                window.ZsrbApp.call("pointToast", {
                  point: data.add_point,
                  msg: data.toast_message
                });
              }
            }
          });
        }
      }
    });
    // 处理所有特殊空格和连续空格
    const processedTitle = computed(() => {
      return props.article.model.title
        .replace(/&nbsp;|\u00A0/g, " ")
        .replace(/\s{2,}/g, " ")
        .trim();
    });

    return {
      clickHeadImage,
      handleClick,
      handleLaunch,
      handleError,
      handleChannelError,
      toComplaint,
      toReporterDetail,
      cdn,
      isVote: vote.isVote,
      isVoted: vote.isVoted,
      goRelateDetail,
      isWechat,
      searchValue,
      chatContent,
      isFocused,
      isExpanded,
      lineCount,
      typeCount,
      fieldRef,
      popFieldRef,
      checkOverflow,
      toChat,
      handleComment,
      handleLike,
      toChatPage,
      toCommentList,
      handleArticlesLike,
      loading,
      handleFocus,
      handleBlur,
      isSend,
      handleChangeExpanded,
      onPopupOpened,
      onPopupClosed,
      toHomePage,
      loadMore,
      processedTitle,
      showTurnApp,
      handlePlayAudio,
      audioIconSrc,
      newsAudioPlayer,
      fontSettingRef,
      showFontSetting,
      likeActive,
      like,
      photos,
      iconSummary,
      iconSummaryActive,
      iconRadio,
      iconRadioActive,
      showSummaryPreview,
      toAiRobot
    };
  }
};
</script>

<style lang="scss" scoped>
@use "@/style/audio.scss" as audio;
@use "@/style/common.scss" as common;
@use "@/style/summary.scss" as summary;

.article-detail {
  background-color: #fff;
  padding-bottom: 60px;
  padding-top: 2px;
  max-width: 750px;
  box-sizing: border-box;
  margin: 0 auto;
}
article {
  width: 91.2%;
  margin-right: auto;
  margin-left: auto;
  text-align: left;
  .zsplus-image {
    width: 100%;
    margin: 0;
    text-align: center;
  }

  .head {
    border-bottom: 1px solid #eee;
    margin-bottom: 5px;

    h1 {
      font-size: 22px;
      line-height: 1.5;
      text-align: left;
    }

    .info {
      margin: 14px 0;
      color: #888;
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      .icon {
        width: 22px;
        height: 22px;
        background: url("../assets/img/header-icon.png") no-repeat center center;
        margin-right: 5px;
        background-size: contain;
        flex-shrink: 0;
      }

      .source {
        margin-right: 5px;
        font-size: 14px;
        flex-shrink: 0;
      }

      .author {
        padding-right: 5px;
        font-size: 14px;
        flex-shrink: 0;
        white-space: pre-wrap;
        max-width: 100%;
      }

      .time {
        padding-right: 5px;
        font-size: 14px;
        flex-shrink: 0;
      }

      .badge {
        height: 20px;
        line-height: 22px;
        font-size: 12px;
        border-radius: 6px;
        color: #aaa;
        text-align: center;
        padding: 2px 8px;
        background: #eee;
        flex-shrink: 0;
      }

      .number {
        font-size: 12px;
        visibility: hidden;
      }
    }
  }
}

.fixed {
  padding-top: 45px;
}

.divider {
  margin: 15px 20px;
  background-color: #fff;
  height: 6px;
}

.channels {
  margin: 10px 2vw 20px 2vw;

  .channel-header {
    display: flex;
    margin: 0 20px;

    .channel-header-image {
      width: 20%;
    }

    .channel-header-title {
      width: 60%;
      font-size: 14px;
      color: #e53531;
    }
  }

  .channel-detail {
    padding: 20px 0 0 2vw;

    .channel-detail-item {
      --van-grid-item-content-padding: 1vw 2vw 1vw 0;

      .channel-detail-item-content {
        font-size: 3.2vw;
        line-height: 26px;
        width: 100%;
        border-radius: 6px;
        height: 26px;
        background: #f8f8f8;
      }
    }
  }
}

.advert {
  margin: 16px 0;
  padding-top: 16px;
  border-top: 7px solid #f8f8f8;
}

.head-advert {
  margin: 0;
}

.complaint {
  font-size: 14px;
  line-height: 40px;
  color: #b8b8b8;
  border: 1px solid #b8b8b8;
  border-radius: 20px;
  width: 56%;
  height: 40px;
  margin: 15px auto;
}

.find_reporter {
  margin-top: 10px;
  .find_reporter_title {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 700;
    color: #303133;
    margin-bottom: 12px;

    .find_reporter_icon {
      margin-right: 5px;
    }
  }
}

.reporters_list {
  display: flex;
  white-space: nowrap;
  overflow-x: scroll;
  padding: 5px;
  margin-left: -5px;
}

.reporters_box {
  display: flex;
  justify-content: space-between;
  box-shadow: 3px 3px 8px 0px rgba(243, 85, 67, 0.2);
  padding: 18px 16px;
  border-radius: 8px;
  margin-right: 20px;
  min-width: 235px;
  flex: 1;
}

.reporters_box:last-child {
  margin-right: 0;
}

.reporters_box_img {
  min-width: 50px;
  width: 50px;
  height: 50px;
  margin-right: 16px;
  border-radius: 50%;
  object-fit: cover;
}

.reporters_box_right {
  width: 100%;
}

.reporters_box_right_top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
}

.reporters_box_right_top .left_item {
  font-size: 16px;
  font-weight: 700;
  color: #303133;
}

.reporters_box_right_top .right_item {
  background: linear-gradient(91.68deg, #ff2f2f, #ff7b55);
  width: 63px;
  height: 22px;
  line-height: 22px;
  border-radius: 11px;
  text-align: center;
  color: #fff;
  font-size: 14px;
}

.reporters_box_right_bottom {
  color: #2a2a2a;
  font-size: 12px;
  line-height: 1.5;
}

.line-2 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  display: -moz-box;
  -moz-line-clamp: 2;
  -moz-box-orient: vertical;
  word-wrap: break-word;
  word-break: break-all;
  white-space: normal;
}

::-webkit-scrollbar {
  display: none;
}

.comment-list {
  padding: 16px 0 14px;
  border-top: 7px solid #fff;
  // border-bottom: 7px solid #F8F8F8;
  margin: 0;

  .comment-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 16px;
    font-weight: 700;
    color: #303133;
    margin-bottom: 12px;
    .comment-title-text {
      display: flex;
      align-items: center;
    }
    .comment-more {
      font-size: 14px;
      color: #606266;
    }
    .comment-icon {
      margin-right: 5px;
    }
  }
}

.comment-title {
  display: flex;
  align-items: center;
  color: #303133;
  font-size: 16px;
  margin-bottom: 12px;
  font-weight: 700;
}

.comment-title-icon {
  width: 24px;
  height: 24px;
  margin-right: 5px;
}

.recommend-list {
  padding: 16px 0 14px;
  margin: 0;
  border-top: 7px solid #fff;
}

.recommend-title {
  display: flex;
  align-items: center;
  color: #303133;
  font-size: 16px;
  // margin-bottom: 12px;
  font-weight: 700;
}

.recommend-title-icon {
  width: 24px;
  height: 24px;
  margin-right: 5px;
}

.comment-item {
  border-bottom: 1px solid #e4e7ed;
  padding-bottom: 12px;
  margin-bottom: 12px;
}
.comment-item-hd-avatar {
  display: flex;
  align-items: center;
}
.common-item-header {
  width: 25px;
  height: 25px;
  margin-right: 9px;
}
.comment-item:last-child {
  border-bottom: none;
  padding-bottom: 0;
  margin-bottom: 0;
}

.comment-item-hd {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  margin-bottom: 10px;
}

.comment-item-hd-left {
  color: #6d6d6d;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  .nickname {
    color: #6d6d6d;
    font-size: 14px;
    max-width: 220px;
    display: flex;
    align-items: center;
    gap: 12px;
  }
  .common-git {
    min-width: 57px;
    width: 57px;
    height: 20px;
  }
  .time {
    color: #c0c4cc;
    font-size: 12px;
  }
}

.comment-item-hd-right {
  color: #c0c4cc;
  display: flex;
  align-items: center;
  .comment-right {
    // width: 60px;
    display: flex;
    // justify-content: space-between;
    align-items: center;
    .like-num {
      margin-left: 7px;
      color: #2a2a2a;
      font-size: 12px;
    }
    .like-icon {
      margin-left: 16px;
    }
  }
}

.comment-item-ft {
  color: #2a2a2a;
  font-size: 16px;
  padding-left: 30px;
}

.load-more {
  text-align: center;
  color: #8e8e8e;
  font-size: 14px;
}

/** article list **/
.article-tips {
  background: #87ceeb;
  padding: 7.5px;
  color: #fff;
  text-align: center;
}

.article-list .item {
  padding: 10px;
  border-bottom: 1px solid #e5e5e5;
  font-size: 0;
  overflow: hidden;
}

.article-list .item.normal .img {
  position: relative;
  float: left;
  width: 30%;
  height: 70px;
  margin-right: 10px;
}

.article-list .item.normal .img img {
  width: 100%;
  height: 100%;
  background: url("../assets/img/placeholder-300x200.png") center center
    no-repeat;
  background-size: contain;
  object-fit: cover;
}

.article-list .item.normal .txt {
  font-size: 16px;
}

.article-list .item.normal .txt .title {
  margin-bottom: 5px;
  line-height: 1.4;
  min-height: 44px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-line-break: auto;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.article-list .item .info {
  font-size: 14px;
  color: #adadad;
}

.article-list .item .info .left {
  float: left;
  display: flex;
  align-items: center;
}

.article-list .item .info .right {
  float: right;
}

.article-list .item .info .badge {
  display: inline-block;
  padding: 0 2px;
  border: 1px solid #f99794;
  border-radius: 2.5px;
  color: #f99794;
  font-size: 12px;
  margin-right: 5px;
  height: 20px;
  line-height: 20px;
  box-sizing: border-box;
}

.article-list .item.bigimg .title {
  font-size: 16px;
  line-height: 1.5;
}

.article-list .item.bigimg .img {
  margin: 5px 0;
  height: 200px;
}

.article-list .item.bigimg .img img {
  width: 100%;
  height: 100%;
  background: url("../assets/img/placeholder-640x360.png") center center
    no-repeat;
  background-size: contain;
  object-fit: cover;
}

.article-list .item.imgset .title {
  font-size: 16px;
  line-height: 1.5;
}

.article-list .item.imgset .img {
  margin: 10px 0;
  height: 74px;
}

.article-list .item.imgset .img img {
  width: 32%;
  float: left;
  margin-right: 2%;
  display: inline-block;
  height: 100%;
  background: url("../assets/img/placeholder-300x200.png") center center
    no-repeat;
  background-size: contain;
  object-fit: cover;
}

.article-list .item.imgset .img img:last-child {
  margin-right: 0;
}

.clearfix:after {
  display: block;
  clear: both;
  content: "";
  visibility: hidden;
  height: 0;
}
.mask {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(16, 16, 16, 0.4);
  z-index: 100;
}
.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 101;
  width: 100%;
  background: #ffffff;
  box-shadow: 0px -4px 8px 0px rgba(0, 0, 0, 0.05);
  padding-bottom: env(safe-area-inset-bottom);
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.chat-footer {
  position: relative;
  text-align: center;
  width: 100%;
  height: auto;
  bottom: 0;
  // width: 70vw;
  .new-chat-btn {
    background-color: #6595fd;
    color: #fff;
    display: inline-flex;
    padding: 3px 10px;
    border-radius: 8px;
    font-size: 14px;
    align-items: center;
  }
  .u-tips {
    font-size: 12px;
    text-align: center;
    padding-bottom: 10px;
    color: #797979;
  }
}
.chat-right {
  text-align: center;
  height: 100%;
  // width: 30vw;
  display: flex;
  justify-content: space-around;
  align-items: center;
  .chat-right-icon {
    // margin-right: 30px;
  }
  .submit-btn {
    border-radius: 19px;
    background: linear-gradient(
      97deg,
      rgba(255, 58, 75, 1) 14%,
      rgba(255, 123, 83, 1) 95%
    );
    height: 34px;
    width: 78px;
    font-size: 16px;
    color: #fff;
    font-weight: 700;
    white-space: nowrap;
  }
}
.chat-input {
  position: relative;
  margin: 10px 10px;
  border-radius: 50px;
  overflow: hidden;
  padding-right: 30px;
  background: rgba(208, 208, 208, 0.3);
  .send-btn {
    position: absolute;
    right: 10px;
    top: 50%;
    margin-top: -14px;
    height: 28px;
    width: 28px;
    background: #c7c7c7;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
  }
  .send-btn.active {
    background: #6172f9;
  }
  .search-input {
    background: rgba(0, 0, 0, 0);
    color: #000;
    padding: 3px 14px;
    overflow: visible;
    :deep(.van-field__control) {
      color: #000;
      line-height: 26px;
      font-size: 14px;
    }
    :deep(.van-field__word-limit) {
      margin-right: -40px;
    }
    :deep(.van-field__left-icon) {
      color: #9e9e9e;
    }
    ::placeholder {
      color: #c0c4cc;
    }
  }
}

.input1 {
  border-radius: 50px;
}
.input2 {
  border-radius: 10px;
}
.input3 {
  border-radius: 10px;
  .send-btn {
    top: auto;
    bottom: 8px;
    margin-top: 0;
  }
  .operate-btn {
    position: absolute;
    top: 8px;
    right: 18px;
  }
}
.input4 {
  padding: 30px 5px 30px !important;
  .send-btn {
    top: auto;
    bottom: 5px;
    margin-top: 0;
  }
  .operate-btn {
    position: absolute;
    top: 10px;
    right: 12px;
  }
}

.pop-box {
  display: flex;
  flex-direction: column;
  height: 100%;
  .pop-title {
    padding: 16px 16px 0;
    display: flex;
    justify-content: flex-end;
  }
  .pop-content {
    flex: 1;
  }
  .pop-btm {
    padding: 0px 16px 16px;
    display: flex;
    justify-content: flex-end;
  }
  .pop-btn {
    height: 28px;
    width: 28px;
    background: #c7c7c7;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
  }
  .pop-btn.active {
    background: #6172f9;
  }
}

.pop-input {
  height: 100%;
  .van-field__body {
    height: 100%;
  }
  .van-field__control {
    line-height: 20px;
    height: 100%;
  }
  :deep(.van-field__body) {
    height: 90%;
  }
  :deep(textarea) {
    height: 100%;
  }
}
</style>

<style lang="scss">
.vote_question_group .active {
  background: #f64e45 !important;
}

.active {
  color: #f64e45 !important;
}

.vote-option-container {
  font-size: 15px;
  line-height: 1.2;
  word-break: break-all;
}

.vote-option-content {
  font-size: 15px;
  font-weight: 700;
}

.vote-option-data {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.vote-option-data .vote-option-progress {
  display: block;
  position: relative;
  width: 75%;
  height: 4px;
  background-color: #ddd;
  border-radius: 100px;
  float: left;
}

.vote-option-progress .curr-progress {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 4px;
  background-color: #f64e45;
  border-radius: 100px;
  transition: width 1.5s;
  -webkit-transition: width 1.5s;
}

.vote-option-data .vote-option-percent {
  font-size: 14px;
  color: #333;
}

.vote-option .vote-option-container .vote-option-pic {
  display: block;
  margin-top: 10px;
  width: 80px;
  height: 80px;
  border: 1px solid #ddd;
  background-color: #fff;
  background-size: cover;
  background-repeat: no-repeat;
}

.vote-btn {
  width: 100%;
  height: 48px;
  border-top: 1px solid #eee;
  font-size: 15px;
  font-weight: 700;
  text-align: center;
  line-height: 48px;
  color: #666;
}

.common-item-reply {
  // background-color: #f8f8f8;
  // border-radius: 8pt;
  // padding: 12px 14px;
  // margin-top: 13px;
  .common-item-reply-count {
    padding-left: 56px;
    color: #1d89ff;
    font-size: 14px;
  }
  .common-item-reply-item {
    padding: 12px 0 0 30px;
    // border-bottom: 1px solid #e4e7ed;
    .common-item-reply-item-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 8px;
      .common-item-reply-item-header-left {
        display: flex;
        align-items: center;
        .common-item-reply-item-header-img {
          width: 20px;
          height: 20px;
          margin-right: 9px;
        }
        .common-item-reply-item-header-name {
          color: #6d6d6d;
          font-size: 14px;
        }

        .common-item-nick-name {
          color: #6d6d6d;
          font-size: 14px;
          display: flex;
          align-items: center;
          gap: 12px;
        }
        .common-git {
          min-width: 57px;
          width: 57px;
          height: 20px;
        }
      }
      .common-item-reply-item-like {
        display: flex;
        align-items: center;
        .like-num {
          margin-left: 7px;
          color: #2a2a2a;
          font-size: 12px;
        }
      }
    }
    .common-item-reply-content {
      color: #2a2a2a;
      font-size: 16px;
      text-align: left;
      margin-bottom: 5px;
      line-height: 1.5;
      padding-left: 26px;
      .common-item-reply-reply-name {
        color: #6d6d6d;
        font-size: 14px;
      }
    }
    .common-item-text {
      color: #1d89ff;
      padding-right: 5px;
    }
    .common-item-reply-bottom {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .common-item-reply-date {
        color: #c0c4cc;
        font-size: 12px;
        padding-left: 26px;
      }
    }
  }
  .common-item-reply-item:last-child {
    border-bottom: none;
    padding-bottom: 0;
  }
}
.line-1 {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  word-break: break-all;
}
</style>
